import React, { useState, useEffect, useCallback } from 'react';
import { X, Printer, ChevronLeft, ChevronRight } from 'lucide-react';
import { buildBulletinHTML, printPages } from './printBuilders';

// THE proper BULLETIN SCOLAIRE — head-of-school only (backend enforces).
// Receives the whole (filtered) student list: the arrows move between
// students without closing the modal.
const BulletinModal = ({ apiCall, year, students, startIndex = 0, onClose, showError }) => {
  const [idx, setIdx] = useState(startIndex);
  const [data, setData] = useState(null);
  const student = students[idx];

  const load = useCallback(async () => {
    try {
      setData(null);
      setData(await apiCall(`/academic/reports/bulletin?studentId=${encodeURIComponent(student.StudentID)}&academicYear=${year}`));
    } catch (err) { showError(err.message); }
  }, [apiCall, student.StudentID, year, showError]);

  useEffect(() => { load(); }, [load]);

  const handlePrint = () => printPages(`Bulletin - ${student.FirstName} ${student.LastName}`, [buildBulletinHTML(data, year)]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[92vh] flex flex-col">
        <div className="flex justify-between items-center p-4 border-b">
          <div className="flex items-center gap-2">
            <button onClick={() => setIdx(i => i - 1)} disabled={idx === 0}
              className="p-1.5 border rounded-lg hover:bg-gray-50 disabled:opacity-30" title="Previous student">
              <ChevronLeft size={16} />
            </button>
            <h3 className="text-lg font-semibold">
              Bulletin scolaire — {student.FirstName} {student.LastName} · {year}
              <span className="ml-2 text-xs text-gray-400 font-normal">{idx + 1} / {students.length}</span>
            </h3>
            <button onClick={() => setIdx(i => i + 1)} disabled={idx >= students.length - 1}
              className="p-1.5 border rounded-lg hover:bg-gray-50 disabled:opacity-30" title="Next student">
              <ChevronRight size={16} />
            </button>
          </div>
          <div className="flex gap-2">
            <button onClick={handlePrint} disabled={!data}
              className="px-4 py-1.5 bg-indigo-600 text-white text-sm rounded-lg hover:bg-indigo-700 disabled:opacity-50 flex items-center gap-2">
              <Printer size={15} /> Print
            </button>
            <button onClick={onClose} className="p-1.5 hover:bg-gray-100 rounded-lg"><X size={20} /></button>
          </div>
        </div>
        <div className="flex-1 overflow-auto p-4">
          {!data ? (
            <p className="text-center text-gray-500 py-8">Building bulletin…</p>
          ) : (
            <div className="border-2 border-gray-300 rounded-lg p-5 bg-white shadow-inner overflow-x-auto"
                 dangerouslySetInnerHTML={{ __html: buildBulletinHTML(data, year) }} />
          )}
        </div>
      </div>
    </div>
  );
};

export default BulletinModal;
